import { Reducer } from 'redux';
import { IAction } from '../types';

export interface RealnameInfoState {
  visible: boolean;
}

export const realnameInfo: RealnameInfoState = {
  visible: false
};

export const setRealnameInfo: (payload: RealnameInfoState) => IAction<RealnameInfoState> = (
  payload: RealnameInfoState
) => ({
  type: 'setRealnameInfo',
  payload
});

const realnameReducer: Reducer<RealnameInfoState, IAction<any>> = (state = realnameInfo, action: IAction<any>) => {
  const { type, payload } = action;
  switch (type) {
    case 'setRealnameInfo':
      return {
        ...payload
      };
    default:
      return state;
  }
};

export default realnameReducer;
